import { render, staticRenderFns } from "./payWechat.vue?vue&type=template&id=3954d1ab&"
import script from "./payWechat.vue?vue&type=script&lang=js&"
export * from "./payWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports